import LoginForm from '../components/LoginForm';
import WaitlistForm from '../components/WaitlistForm';

export default function LoginPage({ onLogin, error, loading }) {
  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh",
      background: "linear-gradient(145deg,#0f172a,#1e293b)", fontFamily: "system-ui,-apple-system,sans-serif",
    }}>
      <div style={{
        background: "white", borderRadius: 20, padding: "44px 36px",
        boxShadow: "0 25px 60px rgba(0,0,0,0.3)", maxWidth: 380, width: "92%",
      }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <span style={{ fontSize: 44 }}>{"\u{1F4B0}"}</span>
        </div>
        <div style={{ fontSize: 26, fontWeight: 800, color: "#0f172a", textAlign: "center", marginBottom: 6 }}>
          Budget Tracker
        </div>
        <div style={{ fontSize: 13, color: "#94a3b8", textAlign: "center", marginBottom: 32 }}>
          Sign in to manage your household budget
        </div>
        <LoginForm onLogin={onLogin} error={error} loading={loading} />
        <div style={{
          marginTop: 24, paddingTop: 20, borderTop: "1px solid #e2e8f0",
          fontSize: 12, lineHeight: 1.55, color: "#64748b", textAlign: "center",
        }}>
          <div style={{ fontWeight: 600, color: "#0f172a", marginBottom: 6 }}>
            Early access - in development
          </div>
          <div style={{ marginBottom: 10 }}>
            Built to help people save. Core features stay free; a few extras will
            be paid later to cover hosting costs.
          </div>
          <a
            href="https://unpackproperty.com.au"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#2563eb", textDecoration: "none", fontWeight: 500 }}
          >
            Also check out unpackproperty.com.au -&gt;
          </a>
          <div style={{ marginTop: 10 }}>
            <a
              href="/preview"
              style={{ color: "#2563eb", textDecoration: "none", fontWeight: 500 }}
            >
              See what's been built -&gt;
            </a>
          </div>
        </div>
        <WaitlistForm />
      </div>
    </div>
  );
}
